import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import SummaryApi from "../common";
import logo from "../asset/logo.png";
import dummyimage from '../asset/person.png';
import noteacher from '../asset/noteacher.png';

const StudentInstructorSelection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const courseId = location.state?.selectedCourseId || sessionStorage.getItem("selectedCourseId");

  const [instructors, setInstructors] = useState([]);

  // Instant restore from sessionStorage → no flash on reload
  const [selectedInstructorId, setSelectedInstructorId] = useState(() => {
    return sessionStorage.getItem("selectedInstructorId") || "";
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const formatImageUrl = (imagePath) => {
    if (!imagePath) return dummyimage;
    const baseUrl = SummaryApi.instructorImage.url.replace("/api", "");
    if (imagePath.startsWith("http")) return imagePath;
    return `${baseUrl}/${imagePath}`;
  };

  useEffect(() => {
    if (!courseId) {
      navigate("/student-panel/course-selection");
      return;
    }

    const fetchInstructors = async () => {
      try {
        const res = await fetch(SummaryApi.instructorByCourseId.url, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ course_id: courseId }),
        });
        const result = await res.json();
        if (result.status) {
          const mapped = result.data.map(inst => ({
            id: inst.instructor_id,
            name: inst.first_name + " " + inst.last_name,
            title: inst.about_instructor1 || "Senior DevOps Engineer",
            rating: Number(inst.rating) || 0,
            experience: inst.total_experience !== "N/A"
              ? `${inst.total_experience}+ Years Experience`
              : "Experience Not Available",
            image: formatImageUrl(inst.instructor_image),
          }));
          setInstructors(mapped);
        } else {
          setError("No instructors found.");
        }
      } catch (err) {
        setError("Error fetching instructors.");
      } finally {
        setLoading(false);
      }
    };

    fetchInstructors();
  }, [courseId, navigate]);

  const handleInstructorSelect = (id) => {
    const idStr = String(id);
    setSelectedInstructorId(idStr);
    sessionStorage.setItem("selectedInstructorId", idStr);
  };

  if (loading) return <div className="text-center py-20 text-gray-600 text-xl">Loading instructors...</div>;

  if (error) return (
    <div className="text-center py-20">
      <img src={noteacher} alt="no teacher" className="w-80 mx-auto mb-8 rounded-xl" />
      <h1 className="text-3xl font-bold text-gray-800 mb-4">No Instructor Found</h1>
      <p className="text-gray-600">Please select another course.</p>
    </div>
  );

  return (
      <div className="relative flex flex-col items-center justify-center w-full min-h-screen bg-white font-inter text-white">

      <div className="w-full flex justify-center mt-8 mb-6">
        <img src={logo} alt="logo" className="w-52 sm:w-64 object-contain" />
      </div>
  <div
    className="
      relative z-10 bg-[#1C3664] shadow-2xl rounded-2xl
      w-[80%] mt-6 mb-16 px-6 sm:px-8 md:px-10 lg:px-12 py-20 
      overflow-hidden
    "
  >
<div className="text-center mb-8 sm:mb-10 md:mb-12 text-white">
  <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-3 sm:mb-4">
    INSTRUCTORS
    <span className="block w-16 sm:w-20 md:w-24 h-0.5 sm:h-1 bg-white mx-auto mt-2 sm:mt-3"></span>
  </h2>
  <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-[#e69818] mt-3 sm:mt-4">
    Choose Your Instructor
  </h3>
  <p className="mt-2 sm:mt-3 text-sm sm:text-base md:text-lg opacity-90">
    Select your preferred expert
  </p>
</div>

        {/* Grid with key → instant visual update on reload */}
        <div
          key={selectedInstructorId || "none"}
          className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8"
        >
          {instructors.map((inst) => (
            <label
              key={inst.id}
              className={`
                cursor-pointer block p-8 rounded-2xl bg-white border-4 transition-all duration-300
                ${selectedInstructorId === String(inst.id)
                  ? "border-[#e69818] scale-110 shadow-xl"
                  : "border-transparent hover:border-gray-300 hover:shadow-md hover:scale-105"
                }
              `}
            >
              <input
                type="radio"
                name="instructor"
                value={inst.id}
                checked={selectedInstructorId === String(inst.id)}
                onChange={() => handleInstructorSelect(inst.id)}
                className="hidden"
              />

              <img
                src={inst.image}
                alt={inst.name}
                className="w-28 h-28 object-cover rounded-full mx-auto mb-5 border-4 border-white shadow-md"
              />

              <h3 className="text-xl font-bold text-[#1C3664] text-center">{inst.name}</h3>
           <p className="text-sm text-gray-600 text-center mt-1 line-clamp-3">
  {inst.title}
</p>


              <div className="flex justify-center items-center gap-1 my-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <FaStar
                    key={i}
                    size={18}
                    className={i < Math.floor(inst.rating) ? "text-yellow-500" : "text-gray-300"}
                  />
                ))}
                <span className="ml-2 text-sm font-medium text-[#1C3664]">({inst.rating})</span>
              </div>

              <p className="text-center text-[#1C3664] font-bold text-sm mt-3">
                {inst.experience}
              </p>
            </label>
          ))}
        </div>

        {/* Buttons */}
<div className="flex justify-between mt-12 sm:mt-16 px-2 sm:px-4">
  <button
    onClick={() => navigate(-1)}
    className="px-6 sm:px-8 md:px-10 py-1 sm:py-3 md:py-4 border-2 border-white text-white font-semibold rounded-lg sm:rounded-xl hover:bg-white hover:text-[#1C3664] transition text-sm sm:text-base"
  >
    &lt; Back
  </button>

  <button
    disabled={!selectedInstructorId}
    onClick={() => navigate("/student-panel/selected-course-details", { state: { selectedInstructorId } })}
    className={`
      px-6 sm:px-8 md:px-10 lg:px-12 py-1 sm:py-3 md:py-4 rounded-lg sm:rounded-xl font-bold text-sm sm:text-base md:text-lg transition-all
      ${selectedInstructorId
        ? "bg-blue-500 text-white hover:bg-blue-600"
        : "bg-gray-400 text-white cursor-not-allowed"
      }
    `}
  >
    Next →
  </button>
</div>
      </div>
    </div>
  );
};

export default StudentInstructorSelection;